function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/@babel/runtime/helpers/assertThisInitialized.js
// module id = 930
// module chunks = 2 4 5 11